import { render, staticRenderFns } from "./PptHeader.vue?vue&type=template&id=2ded1874&"
import script from "./PptHeader.vue?vue&type=script&lang=js&"
export * from "./PptHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptHeader.vue"
export default component.exports